import * as angular from 'angular';
import { goAriaPressedLegacyDirective } from './go-aria-pressed.legacy.directive';

export { GoAriaPressedDirective } from './go-aria-pressed.directive';

export const goAriaPressedLegacyModule = angular.module('goAriaPressedLegacyModule', [])
	.directive('goAriaPressed', goAriaPressedLegacyDirective)
	.name;
